import { Box, Card, Icon, Typography } from "@mui/material";
import { useMemo } from "react";
import CountUp from "react-countup";
import { BLACK, LIGHT_BLACK } from "../../utils/colors";
import { useStyles } from "./styles";

interface CardDashboardProps {
  insights?: number;
  title: string;
  text: string;
}

export function CardDashboard(props: CardDashboardProps) {
  const { title, insights, text } = props;
  const styles = useStyles();

  const config = useMemo(() => {
    const aux = {
      bgBoxIcon: "#E6FFFB",
      bgIcon: "#13C2C2",
      icon: "people",
      insights,
      title,
      text,
    };

    switch (title) {
      case "Contas alcançadas":
      case "Alcance":
        return {
          bgBoxIcon: "#E6FFFB",
          bgIcon: "#13C2C2",
          icon: "people",
          insights,
          title,
          text,
        };
      case "Visualizações":
      case "Impressões":
        return {
          bgBoxIcon: "#F6FFED",
          bgIcon: "#52C41A",
          icon: "visibility",
          insights,
          title,
          text,
        };
      case "Clicks":
        return {
          bgBoxIcon: "#FFF1F0",
          bgIcon: "#F5222D",
          icon: "ads_clicks",
          insights,
          title,
          text,
        };
      case "Frequência":
        return {
          bgBoxIcon: "#E6F7FF",
          bgIcon: "#1890FF",
          icon: "access_time",
          insights,
          title,
          text,
        };
      case "ADS_AGE":
        return {
          bgBoxIcon: "#E6F7FF",
          bgIcon: "#1890FF",
          icon: "access_time",
          insights,
          title,
          text,
        };
      case "ADS_GENDER":
        return {
          bgBoxIcon: "#E6F7FF",
          bgIcon: "#1890FF",
          icon: "access_time",
          insights,
          title,
          text,
        };
      case "Engajamento":
        return {
          bgBoxIcon: "#E6F7FF",
          bgIcon: "#1890FF",
          icon: "insights",
          insights,
          title,
          text,
        };
      case "Enviado com confirmação":
        return aux;
      case "Total de mensagens enviadas":
         return {
          bgBoxIcon: "#E6F7FF",
          bgIcon: "#1890FF",
          icon: "insights",
          insights,
          title,
          text,
        }; 
      case "Reações":
        return {
          bgBoxIcon: "#FFF1F0",
          bgIcon: "#F5222D",
          icon: "favorite_border",
          insights,
          title,
          text,
        };
      case "Enviado sem confirmação":
          return {
            bgBoxIcon: "#F6FFED",
            bgIcon: "#d1d1d1",
            icon: "visibility",
            insights,
            title,
            text,
          };

      case "Mensagens que foram lidas":
        return {
          bgBoxIcon: "#F6FFED",
          bgIcon: "#52C41A",
          icon: "visibility",
          insights,
          title,
          text,
        };
        
      default:
        return {
          bgBoxIcon: "",
          bgIcon: "",
          icon: "",
          insights,
          title,
          text,
        };
    }
  }, [title, insights, text]);

  return (
    <Card className={styles.overviewContent}>
      <Box
        display="flex"
        flexDirection="row"
        gap={1}
        alignItems="center"
        height={70}
      >
        <Box
          className={styles.iconContent}
          sx={{
            background: config.bgBoxIcon,
          }}
        >
          <Icon
            sx={{
              color: config.bgIcon,
            }}
          >
            {config.icon}
          </Icon>
        </Box>
        <Box>
          <Typography fontWeight={600} lineHeight="26px" color={BLACK}>
            <CountUp
              start={0}
              end={config.insights || 0}
              duration={5}
              separator="."
              decimal=","
              decimals={config.title === 'Frequência' ? 2 : 0}
            />
          </Typography>
          <Typography
            fontWeight={500}
            fontSize="12px"
            lineHeight="22px"
            color={LIGHT_BLACK}
          >
            {config.title}
          </Typography>
        </Box>
      </Box>
      <Typography
        fontWeight={500}
        fontSize="12px"
        lineHeight="20px"
        color={LIGHT_BLACK}
        minHeight="110px"
      >
        {config.text}
      </Typography>
    </Card>
  );
}
